import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { ref, onMounted, inject } from "vue";
import SystemService from "@/projects/tenant/modules/system/services/SystemService";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import { ElNotification } from "element-plus";

interface Tag {
  id: number;
  type: string;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountTags',
  setup(__props) {

const accountDetails = inject(AccountInjectionKeys.ACCOUNT_DETAILS);
const isLoading = ref(false);
const tagOptions = ref<Tag[]>([]);
const accountTags = ref<string[]>([]);

const updateData = async () => {
  isLoading.value = true;

  const finalData = {
    id: accountDetails.value.id,
    tagNames: accountTags.value,
  };
  try {
    await AccountService.updateAccountTagsById(
      accountDetails.value.id,
      finalData
    ).then((res) => {
      ElNotification({
        title: "Success",
        message: "Update Success",
        type: "success",
      });
    });
  } catch (err) {
    ElNotification({
      title: "Error",
      message: "Update Failed",
      type: "error",
    });
  }
  isLoading.value = false;
};

const fetchAccountTags = async () => {
  try {
    const tags = await SystemService.getTagsByType("account");
    tagOptions.value = tags;
  } catch (error) {
    console.error("Error fetching account tags:", error);
  }
};

onMounted(async () => {
  await fetchAccountTags();
  accountTags.value = accountDetails.value.tags.map((item: any) => item.name);
});

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!

  return (_openBlock(), _createBlock(_component_el_checkbox_group, {
    modelValue: accountTags.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountTags).value = $event))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagOptions.value, (item, index) => {
        return (_openBlock(), _createBlock(_component_el_checkbox, {
          disable: isLoading.value,
          key: index,
          label: item.name,
          onChange: updateData,
          border: ""
        }, null, 8, ["disable", "label"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})